import { Component } from '@angular/core';

@Component({
  selector: 'cad-overlay-elements',
  templateUrl: './overlay-elements.component.html',
  styleUrls: ['./overlay-elements.component.scss'],
})
export class OverlayElementsComponent {}
